export default __webpack_public_path__ + "static/media/dojo.d684d88d.svg";